/**
 * EncounterSlice Core Reducers
 * 
 * Core CRUD operations for the encounter entity.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { EncounterType } from '../../types/encounterTypes';
import { EncounterSliceState } from '../state';
import { addEditedField } from '../../../shared/sliceUtils';

// =============================================================================
// CORE REDUCERS
// =============================================================================

/**
 * Set the current encounter (from API response or navigation)
 */
export const setEncounter: CaseReducer<EncounterSliceState, PayloadAction<EncounterType | null>> = (
  state,
  action
) => {
  state.currentEncounter = action.payload;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

/**
 * Clear the current encounter
 */
export const clearEncounter: CaseReducer<EncounterSliceState> = (state) => {
  state.currentEncounter = null;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

/**
 * Edit encounter with partial data
 */
export const editEncounter: CaseReducer<EncounterSliceState, PayloadAction<Partial<EncounterType>>> = (
  state,
  action
) => {
  if (state.currentEncounter) {
    state.currentEncounter = { ...state.currentEncounter, ...action.payload };
    // Add all updated fields to editedFields
    Object.keys(action.payload).forEach((field) => {
      addEditedField(state, field);
    });
  }
};
